import { patch } from 'bootstrap/load-snabbdom';
import { VNode } from 'snabbdom/vnode';
import toVNode from 'snabbdom/tovnode';

type callbackFunction = (group : string, tag : string) => void;

function FilterTagItem(
	{
		name,
		tag,
		fixed,
		onClick,
	} : {
		name : string;
		tag : string;
		fixed : boolean;
		onClick() : void;
	}) {


	if (fixed) {
		return <div key={`${tag}`}
					className={'breadcrumb checkbox-filter-breadcrumb filter-breadcrumb breadcrumb-fixed'}>
			<span className="text">{name}</span>
		</div>;
	}

	return <div key={`${tag}`} on-click={onClick}
				className={'breadcrumb checkbox-filter-breadcrumb filter-breadcrumb'}>
		<span className="text">{name}</span>
		<i className="icon icon-202-clear-circle"/>
	</div>;

}

export class FilterTag {
	private container : VNode;
	private sectionsData : Record<string, string>;
	private topcisData : Record<string, string>;
	private periodData : Record<string, string>;


	constructor(element : HTMLElement, sectionsData : Record<string, string>, topicsData : Record<string, string>, periodData : Record<string, string>) {
		this.container = toVNode(element);
		this.sectionsData = sectionsData;
		this.topcisData = topicsData;
		this.periodData = periodData;
	}

	public renderBreadcrumb(
		sections : string[],
		topics : string[],
		period : string,
		query : string,
		onClick : callbackFunction,
	) {

		this.container = patch(this.container, <div></div>);

		this.container = patch(
			this.container,
			<div>
				{sections.map(
					t => <FilterTagItem
						name={this.sectionsData[t]}
						tag={t}
						fixed={false}
						onClick={() => onClick('sections', t)}/>,
				)}
				{topics.map(
					t => <FilterTagItem
						name={this.topcisData[t]}
						tag={t}
						fixed={false}
						onClick={() => onClick('topics', t)}/>,
				)}
				{query &&
				<FilterTagItem
					name={query}
					tag={'query'}
					fixed={false}
					onClick={() => onClick('query', period)}/>
				}
				<FilterTagItem
					name={this.periodData[period]}
					tag={period}
					fixed={true}
					onClick={() => onClick('period', period)}/>

			</div>,
		);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/gcr-pressrelease/FilterTag.tsx